export default __webpack_public_path__ + "static/media/1620.a48af0eb.png";